import New from "./New";
import List from "./List";

const Pages = {
  New,
  List,
};

export default Pages;
